module.exports = __webpack_public_path__ + "img/fit-to-screen-outline.3fab6528.svg";